import {Component, OnInit} from '@angular/core';
import {Button} from "primeng/button";
import {Card} from "primeng/card";
import {Divider} from "primeng/divider";
import {LoaderComponent} from "../../../shared/components/loader/loader.component";
import {FormBuilder, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {Toast} from "primeng/toast";
import {ToggleSwitch} from 'primeng/toggleswitch';
import {TenantSettings} from '../../../tenants/contracts/tenant_settings.interface';
import {UserService} from '../../services/user.service';
import {NotificationService} from '../../../shared/services/notification.service';
import {Textarea} from 'primeng/textarea';
import {InputNumber} from 'primeng/inputnumber';
import {InputText} from 'primeng/inputtext';

@Component({
  selector: 'app-settings',
  imports: [
    Button,
    Card,
    Divider,
    LoaderComponent,
    ReactiveFormsModule,
    Toast,
    ToggleSwitch,
    Textarea,
    InputNumber,
    InputText
  ],
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.scss'
})
export class SettingsComponent implements OnInit {
  loading = false;
  initialSettings: TenantSettings = {};

  settingsForm: FormGroup;

  constructor(private fb: FormBuilder, private userService: UserService, private notificationService: NotificationService) {
    this.settingsForm = this.fb.group({
      features: this.fb.group({
        alertTimer: this.fb.group({
          minutes: [10],
          enabled: [false]
        }),
        automaticMessages: this.fb.group({
          enabled: [false],
          newConversation: this.fb.group({ enabled: [true],  text: ['Your message has been received and will be handled soon.'] }),
          assigned:        this.fb.group({ enabled: [true],  text: ['Your conversation has been assigned to {operator_name}.'] }),
          active:          this.fb.group({ enabled: [true],  text: ['{operator_name} is active in your conversation.'] }),
          closed:          this.fb.group({ enabled: [true],  text: ['Your conversation has been marked as resolved.'] }),
        }),
        revokeConversation: this.fb.group({
          enabled: [false]
        }),
        templateName: ['']
      })
    });
  }

  ngOnInit() {
    this.userService.getSettings().subscribe(data => {
      this.initialSettings = data;
      this.settingsForm.patchValue(this.initialSettings);
      localStorage.setItem('tenantSettings', JSON.stringify({ features: data.features }));
      this.setupDependentControls();
    });
  }

  private setupDependentControls() {
    const alertGroup = this.settingsForm.get('features.alertTimer') as FormGroup;
    alertGroup.get('enabled')?.valueChanges.subscribe(enabled => {
      if (enabled) alertGroup.get('minutes')?.enable({ emitEvent: false });
      else alertGroup.get('minutes')?.disable({ emitEvent: false });
    });
    if (!alertGroup.get('enabled')?.value) alertGroup.get('minutes')?.disable({ emitEvent: false });

    this.setupAutoMessageControls(this.settingsForm.get('features.automaticMessages') as FormGroup);
  }

  private setupAutoMessageControls(group: FormGroup) {
    const msgKeys = ['newConversation', 'assigned', 'active', 'closed'];

    const applyAll = (masterEnabled: boolean) => {
      msgKeys.forEach(key => {
        const sub = group.get(key) as FormGroup;
        if (masterEnabled) {
          sub.get('enabled')?.enable({ emitEvent: false });
          if (sub.get('enabled')?.value) sub.get('text')?.enable({ emitEvent: false });
          else sub.get('text')?.disable({ emitEvent: false });
        } else {
          sub.get('enabled')?.disable({ emitEvent: false });
          sub.get('text')?.disable({ emitEvent: false });
        }
      });
    };

    group.get('enabled')?.valueChanges.subscribe(enabled => applyAll(enabled));
    msgKeys.forEach(key => {
      const sub = group.get(key) as FormGroup;
      sub.get('enabled')?.valueChanges.subscribe(subEnabled => {
        if (group.get('enabled')?.value) {
          if (subEnabled) sub.get('text')?.enable({ emitEvent: false });
          else sub.get('text')?.disable({ emitEvent: false });
        }
      });
    });

    applyAll(group.get('enabled')?.value ?? false);
  }

  save() {
    this.userService.updateSettings(this.settingsForm.value).subscribe(data => {
      this.initialSettings = data;
      localStorage.setItem('tenantSettings', JSON.stringify({ features: data.features }));
      this.notificationService.success('Settings aggiornati con successo.');
    });
  }
}
